import { Fetcher } from "../Fetcher";

export class SynthesisService extends Fetcher {
  static INSTANCE = new SynthesisService();

  constructor() {
    super();
  }

  // TODO - ne pas traiter pour le moment car en attente de spec de la part de l'équipe
  async getSynthesis(
    applicationName: string,
    dataTypeId: string,
    variableName?: string,
  ): Promise<any> {
    if (variableName) {
      return this.get(`applications/${applicationName}/synthesis/${dataTypeId}/${variableName}`);
    }
    else {
      return this.get(`applications/${applicationName}/synthesis/${dataTypeId}`);
    }
  }
}
